export default {
  SET_ACCOUNT(state, payload) {
    state.account = payload;
  },
  SET_LINKS(state, payload) {
    state.links = payload;
  },
};
